// @flow

import { GENDERS } from 'client/constants/health';
import { transformDrugsForPlanRec } from 'client/utils/health/drug';

class BaseApplicantInput {
  constructor({
    age,
    gender,
    isTobaccoUser,
    type,
    uuid,
    usageLevel,
    preConditions,
    providers,
    drugs,
  }) {
    this.age = age;
    this.gender = gender === 'M' ? GENDERS.MALE : GENDERS.FEMALE;
    this.isTobaccoUser = isTobaccoUser;
    this.type = type.toUpperCase();
    this.uuid = uuid;
    this.usageLevel = usageLevel;
    this.preConditions = preConditions;
    this.providers = providers;
    this.drugs = transformDrugsForPlanRec(drugs, uuid);
  }
}

export default BaseApplicantInput;
